import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { tdpStatisticApiRef } from './api/TdpStatisticApi';
import { TdpStatisticClient } from './api/TdpStatisticClient';

export const tdpStatisticPlugin = createPlugin({
  id: 'tdp-statistic',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: tdpStatisticApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new TdpStatisticClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const TdpStatisticPage = tdpStatisticPlugin.provide(
  createRoutableExtension({
    name: 'TdpStatisticPage',
    component: () =>
      import('./components/TdpStatisticPage').then(m => m.TdpStatisticPage),
    mountPoint: rootRouteRef,
  }),
);
